import {
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule,
  NgxMatTimepickerModule,
} from "@angular-material-components/datetime-picker";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { FlatpickrModule } from "angularx-flatpickr";
import { MaterialExampleModule } from "src/material.module";
import { AddTimesheetComponent } from "./pages/add-timesheet/add-timesheet.component";
import { EditTimesheetComponent } from "./pages/edit-timesheet/edit-timesheet.component";
import { ListByMonthComponent } from "./pages/list-by-month/list-by-month.component";
import { MyTimesheetComponent } from "./pages/my-timesheet/my-timesheet.component";
import { VerifyTimesheetViewComponent } from "./pages/verify-timesheet-view/verify-timesheet-view.component";
import { VerifyTimesheetComponent } from "./pages/verify-timesheet/verify-timesheet.component";


import { AppComponent } from "./app.component";
import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth-layout/auth-layout.component";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";

import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { BrowserModule } from "@angular/platform-browser";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { PopupEditProjectComponent } from "../app/pages/master-setup/popup-editproject/popup-editproject.component";
import { AppRoutingModule } from "./app.routing";
import { ComponentsModule } from "./components/components.module";
import { TabComponent } from "./components/tabs/tab.component";
import { TabsComponent } from "./components/tabs/tabs.component";
import { AddMyPopupComponent } from "./pages/add-timesheet/add-my-popup/add-my-popup.component";
import { DashboardComponent } from "./pages/dashboard/dashboard.component";
import { ForgotPasswordComponent } from "./pages/forgot-password/forgot-password.component";
import { ForgotResetpasswordComponent } from "./pages/forgot-resetpassword/forgot-resetpassword.component";
import { EditleaveComponent } from "./pages/leave-management/editleave/editleave.component";
import { LeaveManagementComponent } from "./pages/leave-management/leave-management.component";
import { ReasonComponent } from "./pages/leave-management/reason/reason.component";
import { PopupEditComponent } from "./pages/list-by-month/popup-edit/popup-edit.component";
import { LogoutComponent } from "./pages/logout/logout.component";
import { MasterSetupComponent } from "./pages/master-setup/master-setup.component";
import { PopupAddHolidayComponent } from "./pages/master-setup/popup-addholiday/popup-addholiday.component";
import { PopupAddProjectComponent } from "./pages/master-setup/popup-addproject/popup-addproject.component";
import { PopupEditHolidayComponent } from "./pages/master-setup/popup-editholiday/popup-editholiday.component";
import { tabHolidayComponent } from "./pages/master-setup/tab-holiday/tab-holiday.component";
import { tabProjectComponent } from "./pages/master-setup/tab-project/tab-project.component";
import { PopupProjectApprovalComponent } from "./pages/project-approval/popup-approval/popup-projectapproval.component";
import { ProjectApprovalComponent } from "./pages/project-approval/project-approval.component";
import { PopupUpdateprojectComponent } from "./pages/project-management/popup-updateproject/popup-updateproject.component";
import { ProjectManagementComponent } from "./pages/project-management/project-management.component";
import { PopupRoleComponent } from "./pages/role-management/popup-role/popup-role.component";
import { RoleManagementComponent } from "./pages/role-management/role-management.component";
import { PopupInfoTeamComponent } from "./pages/team-management/popup-info-team/popup-info-team.component";
import { TabProjectManagementComponent } from "./pages/team-management/tab-project/tab-project-management.component";
import { TabTeamManagementComponent } from "./pages/team-management/tab-team/tab-team-management.component";
import { TeamManagementComponent } from "./pages/team-management/team-management.component";
import { BasicInfoComponent } from "./pages/user-management/basic-info/basic-info.component";
import { FirstTimeManagementComponent } from "./pages/user-management/first-time-management/first-time-management.component";
import { PopupAdduserComponent } from "./pages/user-management/popup-adduser/popup-adduser.component";
import { PopupUpdateuserComponent } from "./pages/user-management/popup-updateuser/popup-updateuser.component";
import { UserInfoComponent } from "./pages/user-management/user-info/user-info.component";
import { UserManagementComponent } from "./pages/user-management/user-management.component";
import { EditProfileComponent } from "./pages/user-profile/edit-profile/edit-profile.component";
import { PdpaComponent } from "./pages/user-profile/pdpa/pdpa.component";
import { ResetPasswordComponent } from "./pages/user-profile/reset-password/reset-password.component";
import { DdMmYYYYDatePipe } from "./pipes/dd-mm-yyyy-date.pipe";
import { MergeCell } from "./pipes/mergeCell.pipe";
import { MonthPipe } from "./pipes/month.pipe";
import { RejectedPipe } from "./pipes/reason.pipe";
import { StatusPipe } from "./pipes/status.pipe";
import { HighlightPipe } from "./pipes/highlight.pipe";
import { IntercepterAuthService } from "./services/auth/intercepter-auth.service";
import { AddTimesheetDetailComponent } from './pages/add-timesheet/add-timesheet-detail/add-timesheet-detail.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { CircleLeaveRemainingComponent } from './pages/dashboard/circle-leave-remaining/circle-leave-remaining.component';
// import { AddTimesheetCardComponent } from './pages/add-timesheet/add-timesheet-card/add-timesheet-card/add-timesheet-card.component';

@NgModule({
  imports: [
    DragDropModule,
    NgxMaterialTimepickerModule,
    NgMultiSelectDropDownModule.forRoot(),
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ComponentsModule,
    NgbModule,
    RouterModule,
    AppRoutingModule,
    MaterialExampleModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    FlatpickrModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    ReactiveFormsModule,
    MatInputModule,
    MatAutocompleteModule,
    BrowserModule,
    MatTabsModule,
    MatTooltipModule,
    MatButtonModule,
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    UserManagementComponent,
    LogoutComponent,
    MyTimesheetComponent,
    VerifyTimesheetComponent,
    VerifyTimesheetViewComponent,
    StatusPipe,
    MonthPipe,
    RejectedPipe,
    ListByMonthComponent,
    AddTimesheetComponent,
    EditTimesheetComponent,
    PopupAdduserComponent,
    UserInfoComponent,
    PopupUpdateuserComponent,
    BasicInfoComponent,
    LeaveManagementComponent,
    RoleManagementComponent,
    MonthPipe,
    MergeCell,
    StatusPipe,
    RejectedPipe,
    PopupRoleComponent,
    TabsComponent,
    TabComponent,
    EditleaveComponent,
    ReasonComponent,
    FirstTimeManagementComponent,
    AddMyPopupComponent,
    PopupEditComponent,
    EditProfileComponent,
    ResetPasswordComponent,
    DashboardComponent,
    PdpaComponent,
    ForgotPasswordComponent,
    ForgotResetpasswordComponent,
    DdMmYYYYDatePipe,
    TeamManagementComponent,
    ProjectManagementComponent,
    ProjectApprovalComponent,
    PopupUpdateprojectComponent,
    PopupProjectApprovalComponent,
    PopupInfoTeamComponent,
    MasterSetupComponent,
    PopupEditProjectComponent,
    PopupAddProjectComponent,
    tabProjectComponent,
    tabHolidayComponent,
    PopupAddHolidayComponent,
    PopupEditHolidayComponent,
    TabTeamManagementComponent,
    TabProjectManagementComponent,
    AddTimesheetDetailComponent,
    HighlightPipe,
    PaginationComponent,
    CircleLeaveRemainingComponent,
    // AddTimesheetCardComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: IntercepterAuthService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
